import { Injectable } from '@angular/core';
import { SwiperOptions } from 'swiper/types';

// `import Swiper from 'swiper'` only installs the Resize and Observer modules, so
// only core options belong here — freeMode/navigation/pagination would be ignored.
export const SWIPER_CONFIG: SwiperOptions = {
  slidesPerView: 2.2,
  slidesPerGroup: 1,
  spaceBetween: 16,
  // `setBreakpoint` merges params and never deletes keys, so every value a
  // breakpoint overrides has to exist here too — otherwise it stays sticky when
  // the carousel falls back to the base breakpoint.
  shortSwipes: true,
  longSwipesRatio: 0.5,
  breakpointsBase: 'container',
  observer: true,
  observeParents: true,
  breakpoints: {
    600: {
      slidesPerGroup: 3,
      slidesPerView: 3,
      spaceBetween: 24,
      shortSwipes: true,
      longSwipesRatio: 0.5,
    },
    900: {
      slidesPerGroup: 4,
      slidesPerView: 4,
      spaceBetween: 24,
      shortSwipes: false,
      longSwipesRatio: 0.5,
    },
  },
};

@Injectable({
  providedIn: 'root',
})
export class SwiperConfigService {
  readonly swiperConfig: SwiperOptions = SWIPER_CONFIG;
}
